<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} | SITE_NAME` : `SITE_NAME`
    }}</template>
  </metainfo>
  <router-view></router-view>
</template>

<script setup>
// cookies的使用
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

// 多语种
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { lang } from "@/util/base";

// 默认使用玩家保存的语言
if (cookies.get("XH-WEB")) {
  locale.value = cookies.get("XH-WEB").page_lang || lang();
}

// 定义全局变量，GA统计语言标识
window.XHlanguage = cookies.get("XH-WEB").page_lang || lang();
</script>
